import React from 'react'
import LoginForm from './LoginForm'

function LoginPage() {
    return (
        <div className='bg-slate h-screen flex items-center' style={{backgroundColor:"#57787c"}}>
            <div className='flex w-full px-14'>
                <div className='w-1/2 flex justify-center'>
                    <img src="/back.png" alt="Recity" className='max-h-[80vh] object-contain' />
                </div>
                <div className='w-1/2 flex justify-center'>
                    <div className='bg-white rounded-3xl p-8 max-w-md w-full'>
                        <h1 className='text-4xl text-gray-400 mb-6'></h1>
                        <LoginForm />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LoginPage